import { useGetFileBlobSrc } from '@/hooks/use-get-file-src.hook';
import { useGetCompanyProfilePicture } from '@/modules/Companies/queries/get-company-profile-picture';
import { AvatarSize, UserAvatar } from '..';

type CompanyAvatarProps = {
  companyId: number;
  name: string;
  size: AvatarSize;
  hasImage: boolean;
  allowEdit?: boolean;
  onUploadClick?: (file: File) => void;
  onDeleteClick?: () => void;
  isLoading?: boolean;
  imageId?: number;
};

export const CompanyAvatar = ({
  size,
  companyId,
  name,
  hasImage,
  allowEdit,
  onUploadClick,
  onDeleteClick,
  isLoading,
  imageId,
}: CompanyAvatarProps) => {
  const { data: image, isLoading: isLoadingFile } = useGetCompanyProfilePicture(
    companyId,
    hasImage,
  );
  const profilePictureUrl = useGetFileBlobSrc(image);

  return (
    <UserAvatar
      isLoading={(isLoadingFile || isLoading) && hasImage}
      imageSrc={profilePictureUrl}
      name={name}
      size={size}
      allowEdit={allowEdit}
      onUploadClick={onUploadClick}
      onDeleteClick={onDeleteClick}
      imageId={imageId}
      fetchImage={false}
    />
  );
};
